export function isNullOrWhiteSpace(str) {
    return str === null || str.match(/^ *$/) !== null;
}

export function absoluteLinkIsValid(link: string) {
    if (isNullOrWhiteSpace(link)) return true;
    if (link.indexOf('http://') === 0 || link.indexOf('https://') === 0) return true;
    return false;
}
